import SharedLayout from "utils/SharedLayout";
import { HomeRedirect } from "./HomeRedirect";
import HRHome from "pages/HRHome";
import HRSidebar from "components/sidebar/HRSidebar";
import ProfileTabs from "pages/profile/ProfileTabs";
import ChangePassword from "pages/auth/ChangePassword";
import AllEmployeeList from "pages/all_employee/AllEmployeeList";
import SubmittedFormsEmployee from "pages/submitted_forms_by_employee/SubmittedFormsEmployee";
import LeaveManager from "pages/leaves_manager/LeaveManager";
import BioMetricTrackModule from "pages/biometric_track_module_HR/BioMetricTrackModule";
import BellNotifications from "pages/notification_manager/BellNotifications";
import EmployeeOfferLetter from "pages/offer_letter/EmployeeOfferLetter";
import ChatWidget from "../pages/chatWidget";
import FormsManager from "pages/hr_forms_manager/FormsManager";
import HiringView from "pages/hr_forms_manager/hiring/HiringView";
import AddHiring from "pages/hr_forms_manager/hiring/AddHiringForm";
import HiringEdit from "pages/hr_forms_manager/hiring/EditHiring";
import OnboardingView from "pages/hr_forms_manager/onboarding/OnboardingView";
import AddOnboarding from "pages/hr_forms_manager/onboarding/AddOnboardingForm";
import EditOnboarding from "pages/hr_forms_manager/onboarding/EditOnboarding";
import SuggestedForms from "pages/hr_suggested_forms/SuggestedForms";
import SuggestedHiringView from "pages/hr_suggested_forms/hiring/HiringView";
import SuggestedOnboardingView from "pages/hr_suggested_forms/onboarding/OnboardingView";
import EmployeeTaskScheduling from "pages/employee_task_scheduling/EmployeeTaskScheduling";
import EmployeeRequest from "pages/employee_request/EmployeeRequest";
import InterviewManager from "pages/interview/InterviewManager";
import BackgroundVerification from "pages/background_verification/BackgroundVerification";
import MailManager from "pages/mail_manager/MailManager";
import DocumentManager from "pages/document_manager/DocumentManager";
import ScheduleManager from "pages/schedule_manager/EmployeeShiftScheduling";
import TimesheetManagement from "pages/timesheet_manager/TimesheetManagement";
import AttendanceReportModule from "pages/attendance-report/AttendanceReportModule";
import PayrollWages from "pages/payroll_wages/PayrollWages";
import ReportsModule from "pages/reports_module/ReportsModule";
import GeoAreaLocations from "pages/geo_access/GeoAreaLocations";
import EmployeeRecommendation from "pages/employee_recommendation/EmployeeRecommendation";
import Training from "pages/training/Training";
import Compilence from "pages/complaince/compilence";
import Credentialing from "pages/credentialing";
import { elements } from "chart.js";
import ManageJobs from "pages/manage_jobs/ManageJobs";
import AuthorizationRoute from "utils/AuthorizationRoute";
const HRRoutes = {
  path: "/",
  element: (
    <>
      <SharedLayout type={<HRSidebar />} />
      <ChatWidget />
    </>
  ),
  children: [
    { path: "/dashboard", element: <HRHome /> },
    {path:"/compilence", element: <Compilence/>},
    { path: "/credentialing", element: <Credentialing /> },
    { path: "/all-employee-list", element: <AllEmployeeList /> },
    { path: "/interview-manager", element: <InterviewManager /> },
    { path: "/employee-request", element: <EmployeeRequest /> },
    { path: "/offer-letter", element: <EmployeeOfferLetter /> },
    { path: "/forms-manager", element: <FormsManager /> },
    { path: "/forms-manager/addhiring", element: <AddHiring /> },
    { path: "/forms-manager/view", element: <HiringView /> },
    { path: "/compilence", element: <Compilence /> },
    { path: "/credentialing", element: <Credentialing /> },
    { path: "/training-certification", element: <Training /> },
    { path: "/forms-manager/hiring-edit", element: <HiringEdit /> },
    { path: "/forms-manager/addonboarding", element: <AddOnboarding /> },
    { path: "/forms-manager/onboarding-edit", element: <EditOnboarding /> },
    { path: "/suggested-forms", element: <SuggestedForms /> },
    { path: "/suggested-forms/hiring-view", element: <SuggestedHiringView /> },
    {
      path: "/suggested-forms/onboarding-view",
      element: <SuggestedOnboardingView />,
    },
    { path: "/employee-tasks-scheduling", element: <EmployeeTaskScheduling /> },
    { path: "/biometric-track-module", element: <BioMetricTrackModule /> },
    { path: "/submittedFormsByEmployee", element: <SubmittedFormsEmployee /> },
    { path: "/leave-manager", element: <LeaveManager /> },
    { path: "/profile", element: <ProfileTabs /> },
    { path: "/notification-list", element: <BellNotifications /> },
    { path: "/change-password", element: <ChangePassword /> },
    { path: "/background-verification", element: <BackgroundVerification /> },
    { path: "/mail-manager", element: <MailManager /> },
    { path: "/document-manager", element: <DocumentManager /> },
    { path: "/schedule-manager", element: <ScheduleManager /> },
    { path: "/geo-area-locations", element: <GeoAreaLocations /> },
    { path: "/timesheet-manager", element: <TimesheetManagement /> },
    { path: "/attendance-report", element: <AttendanceReportModule /> },
    { path: "/payroll-wages", element: <PayrollWages /> },
    { path: "/reports", element: <ReportsModule /> },
    { path: "/employee-recomendation", element: <EmployeeRecommendation /> },
    { path: "/manage-jobs", element: <ManageJobs /> },
    { path: "/manage-job", element: <ManageJobs /> },
    { path: "*", element: <HomeRedirect to="/dashboard" /> }
  ],
};

export default HRRoutes;
